// extracted by mini-css-extract-plugin
export default {"placemark":"rR62y"};